export default __webpack_public_path__ + "static/media/jobs-value-deliver-fast.2b2d8838.svg";